import { gql, TypedDocumentNode } from '@common/hooks';

type ApprovalsConfigMutationResponse = {
  approvalsConfig: {
    requireStaffingRequestDocument: boolean;
    staffingRequestDocumentNote?: string;
    requireExtensionOfferDocument: boolean;
    extensionOfferDocumentNote?: string;
  };
};

type ApprovalsConfigMutationArg = {
  input: {
    requireStaffingRequestDocument: boolean;
    staffingRequestDocumentNote?: string;
    requireExtensionOfferDocument: boolean;
    extensionOfferDocumentNote?: string;
  };
};

export const UpsertApprovalsConfigMutation: TypedDocumentNode<
  ApprovalsConfigMutationResponse,
  ApprovalsConfigMutationArg
> = gql`
  mutation UpsertApprovalsConfig($input: OrganizationApprovalsConfigInput!) {
    result: upsertApprovalConfig(input: $input) {
      approvalsConfig {
        id
      }
    }
  }
`;
